<template>
	<el-card class="mt-3 br-12">
		<el-row :gutter="20">
			<el-col :span="18">
				<h2 v-if="checkCompany.is_mcd || checkCompany.is_mcd_north" class="my-2">Fixed / Non-Coverage Activities</h2>
				<h2 v-else class="my-2">Non-Coverage Activities</h2>
				<p>
					All non-coverage activities
				</p>
			</el-col>
			<el-col :span="6" class="text-right">
				<div class="text-right pt-8">
					<!-- <el-button
						:disabled="!hasAdminAccess"
						class="primary-settings-button__save"
						size="small"
						icon="el-icon-time"
						@click="openHourlyView"
					>
						View Hourly
					</el-button> -->
					<el-button
						:disabled="!hasAdminAccess || regionAccess || sub_regionAccess"
						type="warning"
						plain
						size="small"
						icon="el-icon-circle-plus-outline"
						class="primary-settings-button"
						@click="openNonCoverageActivity"
						>Add New</el-button
					>
				</div>
			</el-col>
		</el-row>
		<el-row :gutter="20" class="mt-2">
			<el-col :span="24">
			<!--
				<el-table
					:data="mappedSectionsAndStations.filter(el => el.setups_for_section.filter(e => e.non_coverage_hours_defined).length)"
					style="width: 100%"
					max-height="400"
					row-class-name="custom-non-cov-cell"
				>
					<el-table-column prop="section" label="Section" width="180">
						<template slot-scope="scope">
							{{ scope.row.name }}
						</template>
					</el-table-column>
					<el-table-column label="Station / Function">
						<template slot-scope="scope">
							<el-row v-if="scope.row.setups_for_section.filter(element => element.non_coverage_hours_defined).length" :gutter="20">
								<el-col :span="10">
									&nbsp;
								</el-col>
								<el-col :span="10">
									<span class="font-bold">Activities</span>
								</el-col>
								<el-col :span="4">
									&nbsp;
								</el-col>
							</el-row>
							<el-row v-for="(item, index) in scope.row.setups_for_section.filter(element => element.non_coverage_hours_defined)" :key="'setups-item-'+index" class="pb-3 light-border-bottom">
								<el-col :span="10">
									<primary-tag>{{ item.function_name }}</primary-tag>
								</el-col>
								<el-col :span="10">
									<template
										v-if="
											grouped_daily_activities &&
											grouped_daily_activities[scope.row.id] &&
											grouped_daily_activities[scope.row.id][item.function] &&
											grouped_daily_activities[scope.row.id][item.function].length
										"
										>
										<el-row v-for="(activityItem, activityIndex) in grouped_daily_activities[scope.row.id][item.function]" :key="'activity-item-'+activityIndex" :gutter="20" class="mb-3">
											<el-col :span="24">
												{{ activityIndex + 1 }}. {{ activityItem.activity_name }}
											</el-col>
										</el-row>
									</template>
									<template v-else>
										&#8212;
									</template>
								</el-col>
								<el-col :span="4">
									<div class="text-right">
										<span class="mr-4">
											<img
												:class="[isAdmin == 'admin' ? 'cursor-pointer' : 'cursor-not-allowed']"
												src="../../../../../assets/icons/edit-icon.svg"
												width="12"
												class="cursor-pointer"
												@click="isAdmin == 'admin' ? openEditNonCoverageCompanyActivity(scope.row, item.function) : ''"
											/>
										</span>
										<span>
											<img
												:class="[isAdmin == 'admin' ? 'cursor-pointer' : 'cursor-not-allowed']"
												src="../../../../../assets/icons/trash-icon.svg"
												width="12"
												class="cursor-pointer"
												@click="isAdmin == 'admin' ? deleteSectionStationMappingRow(item) : ''"
											/>
										</span>
									</div>
								</el-col>
							</el-row>
						</template>
					</el-table-column>
				</el-table>
			-->
			<el-table
					:data="row_wise_company_non_coverage_activities"
					style="width: 100%"
					max-height="400"
					row-class-name="custom-non-cov-cell"
				>
					<el-table-column prop="name" label="Section"></el-table-column>
					<el-table-column label="Station / Function">
						<template slot-scope="scope">
							<primary-tag>{{ scope.row.function_name }}</primary-tag>
						</template>
					</el-table-column>
					<el-table-column label="Activities">
						<template slot-scope="scope">
							<template
								v-if="scope.row.non_coverage_activities && scope.row.non_coverage_activities.length"
							>
								<el-row v-for="(activityItem, activityIndex) in scope.row.non_coverage_activities" :key="'activity-item-'+activityIndex" :gutter="20" class="m-2">
									<el-col :span="24" style="line-height: 26px;">
										{{ activityIndex + 1 }}. {{ activityItem.activity_name }}
									</el-col>
								</el-row>
							</template>
							<template v-else>
								&#8212;
							</template>
						</template>
					</el-table-column>
					<el-table-column  prop="time_frame" label="Time Frame">
						<template   slot-scope="scope">
							<template
								v-if="scope.row.non_coverage_activities && scope.row.non_coverage_activities.length"
							>
								<el-row v-for="(activityItem, activityIndex) in scope.row.non_coverage_activities" :key="'activity-item-'+activityIndex" :gutter="20" class="m-2">
									<el-col v-if="activityItem.time_frame.length" :span="24">
										<primary-tag v-for="(frame, index) in activityItem.time_frame" :key="frame + index + Math.random()" class="ns-custom-tag-01">{{ frame.replace("_", " ") }}</primary-tag>
									</el-col>
									<el-col v-else :span="24" style="line-height: 26px;">
										&#8212;
									</el-col>
								</el-row>
							</template>
							<template v-else>
								&#8212;
							</template>
							<!-- <span v-if="scope.row.non_coverage_activities.length">
								<span v-if="scope.row.non_coverage_activities[0].time_frame.length">
									<primary-tag v-for="(frame, index) in scope.row.non_coverage_activities[0].time_frame" :key="frame + index + Math.random()">{{ frame }}</primary-tag>
								</span>
								<span v-else> - </span>
							</span> -->
						</template>
					</el-table-column>
					<el-table-column>
						<template slot-scope="scope">
							<div class="text-right">
								<span class="mr-4">
									<img
										:class="[isAdmin == 'admin' ? 'cursor-pointer' : 'cursor-not-allowed']"
										src="../../../../../assets/icons/edit-icon.svg"
										width="12"
										class="cursor-pointer"
										@click="isAdmin == 'admin' ? openEditNonCoverageCompanyActivity(mappedSectionsAndStations.find(el => el.id == scope.row.store_section), scope.row.function) : ''"
									/>
								</span>
								<span>
									<img
										:class="[isAdmin == 'admin' ? 'cursor-pointer' : 'cursor-not-allowed']"
										src="../../../../../assets/icons/trash-icon.svg"
										width="12"
										class="cursor-pointer"
										@click="isAdmin == 'admin' ? deleteSectionStationMappingRow(scope.row) : ''"
									/>
								</span>
							</div>
						</template>
					</el-table-column>
				</el-table>
			</el-col>
		</el-row>
		<section-and-station-mapping></section-and-station-mapping>
	</el-card>
</template>

<script>
import settingsMixin from "../../../../../../mixins/settingsMixin";
import SectionAndStationMapping from "./SectionAndStationMapping.vue";
import PrimaryTag from "./PrimaryTag.vue";
// import ActivityTag from "./ActivityTag.vue";
export default {
    name: "AllNonCoverageActivities",
	components: {
		SectionAndStationMapping,
		PrimaryTag,
		// ActivityTag
	},
    mixins: [settingsMixin],
}
</script>

<style lang="scss" scoped>
.time-range {
	font-family: 'Open Sans';
	font-style: normal;
	font-weight: 400;
	font-size: 16px;
	line-height: 22px;
	color: #333333;
}
.more-time {
	font-family: 'Open Sans';
	font-style: normal;
	font-weight: 600;
	font-size: 12px;
	line-height: 16px;
	color: #BFC0C4;
}
.mh-36 {
	min-height: 42px;
}
.light-border-bottom {
	/* border-bottom: 1px solid #BFC0C4;
	border-left: 1px solid #BFC0C4; */
	padding: 15px;
}
</style>

<style lang="scss">
.el-table__row.custom-non-cov-cell {
	td.el-table__cell {
		vertical-align: top !important;
	}
}
.ns-custom-tag-01{
	margin: 2px !important;
    padding: 0px 10px !important;
    font-size: 10px !important;
}
</style>
